import * as React from 'react';
import { InjectedRouter, PlainRoute } from 'react-router';
import { Location } from 'lib/ReactRouterTypes';
import AdminOrganizationSettingsContainer from './AdminOrgApprovalSettingsContainer';
import AdminOrganizationSettingsView from './AdminOrgApprovalSettingsView';
import { OrganizationType } from 'globalTypes';
import { withRouter } from 'app/context/Router';

type Props = {
  organizationUUID: string;
  orgId: string;
  groupCode: string;
  orgType: OrganizationType;
  route: PlainRoute;
  router: InjectedRouter;
  location: Location;
};

function AdminOrganizationSettings(props: Props) {
  const { organizationUUID, route, groupCode, orgType, router, location } = props;

  return (
    <AdminOrganizationSettingsContainer organizationUUID={organizationUUID}>
      {({ approvalSettings, onSave }) => {
        return (
          <AdminOrganizationSettingsView
            approvalSettings={approvalSettings}
            onSave={onSave}
            orgUuid={organizationUUID}
            groupCode={groupCode}
            orgType={orgType}
            route={route}
            router={router}
            location={location}
          />
        );
      }}
    </AdminOrganizationSettingsContainer>
  );
}

export { AdminOrganizationSettings };
export default withRouter(AdminOrganizationSettings);
